// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_ReportsList_wrapper__1TgZy","reportType":"_ReportsList_reportType__rkl4s","date":"_ReportsList_date__34EMi"};